import React, { Fragment, type PropsWithChildren, useEffect, useState } from "react";
import flex from "../../../styles/flex";
import { TabbedViewPageChild } from "./TabbedViewPage";
import styles from "./styles";
import classes from "./styles.module.css";

import { Button, Select, useMediaQuery, useTheme } from "@mui/material";
import AnimateFrom from "../../animations/AnimateFrom";

interface TabbedViewProps {
    selectedIndex?: number,
    animated?: boolean,
    preLoad?: boolean;
    selectFirstIndexOnTabChanges?: boolean,
    onSelectedIndexChange?: (selectedIndex: number) => void
}

const TabbedView = (props: PropsWithChildren<TabbedViewProps>) => {
    const [currentIndex, setSelectedIndex] = useState(props.selectedIndex == null ? 0 : props.selectedIndex);
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down('xs'));

    let selectedIndex = currentIndex;
    let tabTitles = "";
    const validChildren = props.children !== null ? React.Children.toArray(props.children).filter(child => child) : [];
    if (props.children != null) {
        let selectedIndexIsVisible = false;
        let firstVisibleIndex = -1;

        validChildren.map((child, i) => {
            const tab = child as TabbedViewPageChild;
            if (tab.props.visible != false) {
                if (firstVisibleIndex == -1) {
                    firstVisibleIndex = i;
                }
                if (selectedIndex == i) {
                    selectedIndexIsVisible = true;
                }
                tabTitles += tab.props.title;
            }
            return null;
        });

        if (selectedIndexIsVisible == false && firstVisibleIndex != -1) {
            selectedIndex = firstVisibleIndex;
        }
    }


    useEffect(() => {
        if (props.selectedIndex != null) {
            setSelectedIndex(props.selectedIndex);
        }
    }, [props.selectedIndex]);

    useEffect(() => {
        if (props.selectFirstIndexOnTabChanges != false) {
            setSelectedIndex(0);
        }
    }, [tabTitles]);

    if (isSmallDevice) {
        return <div style={flex.flexColumns}>
            <div style={flex.flexAuto}>
                <div style={flex.flexRows}>
                    <Select
                        data-testid="tabbed-view-mobile-select"
                        native
                        style={{ width: "100%", marginBottom: 20, fontWeight: "bold", borderRadius: 5, padding: 5 }}
                        value={selectedIndex}
                        onChange={(e) => {
                            setSelectedIndex(e.target.value as number);
                        }}
                    >
                        {validChildren.map((child, i) => {
                            const tab = child as TabbedViewPageChild;
                            return <option key={i} value={i} title={tab.props.title}>{tab.props.title}</option>
                        })}
                    </Select>
                </div>
            </div>
            <div style={flex.flexFill}>
                {validChildren.map((child, i) => {
                    return <div key={i} style={selectedIndex == i ? styles.tabPageActive : styles.tabPage}>{child}</div>
                })}
            </div>
        </div>
    }

    return <div style={{ ...flex.flexColumns, height: "100%" }} className="tabbedView">
        <div className={`tabbedViewTabs ${classes.tabbedViewTabs}`}>
            {validChildren.map((child, i) => {
                const tab = child as TabbedViewPageChild;

                if (tab.props.visible == false) {
                    return <Fragment key={i}></Fragment>
                }

                const classNames = [
                    classes.tab,
                    selectedIndex === i ? classes.tabActive : null,
                    selectedIndex === i ? "tabbedViewTabActive" : "tabbedViewTab",
                ]
                    .filter((x) => x)
                    .join(' ');

                return <div style={{ display: "inline-block" }} key={i} className={classNames}>
                    <Button data-testid={`tab-button-${i}`} onClick={() => {
                        if (props.onSelectedIndexChange) {
                            props.onSelectedIndexChange(i);
                        }
                        setSelectedIndex(i);
                    }} >{tab.props.title}</Button>
                </div>
            })}
        </div>

        <div style={flex.flexFill} className="tabbedViewContent">
            {validChildren.map((child, i) => {
                if (selectedIndex != i && props.preLoad != false) {
                    return <Fragment key={i}></Fragment>
                }

                const classNames = [
                    "tabbedViewContentInner",
                    classes.tabPage,
                    selectedIndex === i ? classes.tabPageActive : null,
                ]
                    .filter((x) => x)
                    .join(' ');

                return <div className={classNames} key={i}>
                    {
                        props.animated != false && (
                            <AnimateFrom delay={0.3} style={{
                                opacity: 0,
                                x: 50
                            }}>
                                {child}
                            </AnimateFrom>
                        )
                    }
                    {
                        props.animated == false && (
                            child
                        )
                    }
                </div>
            })}
        </div>
    </div>

}

export default TabbedView;
